export default __webpack_public_path__ + "static/media/about-me-pic.fe910797.png";